import { get } from 'global/lib/lodash';

export const getDisplayScore = (opt, i, scorecardConfig = null) => {
  if (!scorecardConfig) {
    return get(opt, 'value', i);
  } else {
    const { forceVal } = scorecardConfig;
    const val = get(opt, 'value', 0);

    if (val === -1) {
      return 'N/O';
    }
    if (val === null || isNaN(val)) {
      return 'N/A';
    }
    if (forceVal) {
      return val;
    }

    const maxScore = parseFloat(scorecardConfig.maxScore);
    const minScore = parseFloat(scorecardConfig.minScore);

    return minScore === 0 && maxScore === 1 ? val + '%' : parseFloat(((val / 100) * (maxScore - minScore) + minScore).toFixed(4)) * get(opt, 'weight', 1);
  }
};

export const getDisplayValue = (opt, scorecardConfig = null) => {
  if (!scorecardConfig) {
    return '';
  }
  return get(scorecardConfig, 'maxScore') === 1 && get(scorecardConfig, 'minScore') === 0
    ? get(opt, 'value') === 100
      ? 'PASS'
      : get(opt, 'value') === -1
      ? 'N/O'
      : 'FAIL'
    : getDisplayScore(opt, get(opt, 'value'), scorecardConfig);
};

export const getHeatchartScore = (opt, config) => {
  const { max_score, min_score } = config;
  const val = get(opt, 'value', 0);
  const toFix = max_score > 1 ? 2 : 0;
  const isPercent = max_score == 1;
  return isNaN(val) ? 'N/A' : val === -1 ? 'N/O' : `${(((val / (isPercent ? 1 : 100)) * (max_score - min_score) + min_score) * get(opt, 'weight', 1)).toFixed(toFix)}${isPercent ? '%' : ''}`;
};

export default getDisplayScore;
